import { Grid, Modal } from "@mui/material";
import { useAppSelector } from "../../redux";
import { selectAttempts } from "./QueueSlice";
import { IAttempt } from "../../types/images";
import Images from "../UserModal/Images";
import { useMeasure } from "./hooks";

interface FullScreenProps {
  attempt: number;
  fullScreen: boolean;
  handleClose(): void;
}

export function FullScreenImage(props: FullScreenProps) {
  const { attempt, fullScreen, handleClose } = props;
  const { elementHeight, elementWidth } = useMeasure();
  const attempts = useAppSelector(selectAttempts);
  const height = window.screen.height;

  if (!attempts) return null;
  const imgSize = attempts[attempt].images.selfieRef || attempts[attempt].images.document ? 6 : 12;

  return (
    <Modal
      open={fullScreen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={{ textAlign: "center" }}
    >
      <Grid
        container
        direction="row-reverse"
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{
          maxWidth: elementWidth(0.8),
          maxHight: elementHeight(0.7),
          position: "absolute",
          backgroundColor: "white",
          display: "flow",
          textAlign: "center",
          zIndex: 1000,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          margin: "auto, 0px",
          //   overflow: "scroll",
        }}
      >
        <Grid item xs={10} xl={10} sx={{}}>
          <Images
            images={(attempts as IAttempt[])[attempt].images}
            imgSize={imgSize}
            imgHeight={height * 0.7}
            imgControl={true}
          />
        </Grid>
      </Grid>
    </Modal>
  );
}
